import { useEffect, useState } from 'react'

/**
 * 환경 배지 — **개발일 때만** 헤더에 표시한다(2026-09-01 환경 구분,
 * docs/30_실행/환경-구분-운영개발.md).
 *
 * 왜 필요한가: 운영(EC2 `haebom.it`·`admin.haebom.it`)과 개발(NKS `*.codnut.com`)은
 * **같은 이미지로 돌아서** 화면만 봐서는 구분이 안 됐다. 실데이터가 사는 곳은 운영 하나이고,
 * 개발인 줄 알고 지우거나 운영인 줄 알고 합성 데이터를 넣는 사고가 가능한 상태였다.
 *
 * **빌드타임 플래그(`VITE_*`)를 쓰지 않는다.** 그렇게 하면 환경마다 이미지를 따로 구워야 하고,
 * 인계(§10-3) 때 "어느 이미지가 어느 환경 것인가"가 또 하나의 외울 거리가 된다. 서버가
 * `/health`에 자기 `env`를 실으므로(`apps/api/src/routes/health.ts`) 런타임에 물어본다 —
 * 이미지는 하나이고, 배지는 **접속한 서버가 스스로 말한 것**이라 어긋날 수가 없다.
 *
 * **운영에서는 아무것도 그리지 않는다.** 시민·이티랩이 보는 화면에 개발 표식이 나가면
 * 그 자체가 사고다. 그래서 기본값은 "안 그림"이고, `development`를 확인했을 때만 켠다 —
 * 조회 실패·응답 이상도 전부 "안 그림"으로 떨어진다(실패가 표식을 만들지 않는다).
 */
export function EnvBadge() {
  const [env, setEnv] = useState<string | null>(null)

  useEffect(() => {
    // 언마운트 후 setState를 막는다(라우팅이 빠를 때 경고가 뜬다).
    let alive = true
    const ac = new AbortController()

    // 절대 URL을 쓰지 않는다(§10-5) — 앞단(EC2 Caddy · NKS nginx)이 /health를 API로 넘긴다.
    fetch('/health', { signal: ac.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((body: unknown) => {
        if (!alive) return
        const value =
          typeof body === 'object' && body !== null && 'env' in body
            ? (body as { env: unknown }).env
            : null
        setEnv(typeof value === 'string' ? value : null)
      })
      .catch(() => {
        // 조용히 넘긴다 — 배지는 보조 표시라 실패가 콘솔 에러로 남으면 안 된다
        // (smoke-prod·verify-dev-overlay가 "콘솔 에러 0건"을 검사한다).
      })

    return () => {
      alive = false
      ac.abort()
    }
  }, [])

  if (env !== 'development') return null

  return (
    <span className="env-badge" title="개발 서버 — 이 데이터는 운영과 무관하다">
      개발
    </span>
  )
}
